<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Unit</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Unit</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="unit.id === null">New</span>
                  <span v-else>{{ unit.unit_no }}</span>
                </li>
              </ol>
              <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
              <button type="button" @click="checkUnit" class="btn btn-sm btn-soft-primary pull-left" v-if="unit.status === 'scheduled'"><i class="fa fa-check" aria-hidden="true"></i> Check Unit</button>
              <button type="button" @click="startUnit" class="btn btn-sm btn-soft-primary pull-left" v-if="unit.status === 'check'"><i class="fa fa-check" aria-hidden="true"></i> Start Unit</button>
              <button type="button" @click="finishUnit" class="btn btn-sm btn-soft-primary pull-left" v-if="unit.status === 'start'"><i class="fa fa-check" aria-hidden="true"></i> Finish Unit</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-list">
            <div class="card-header">
              <h5 v-if="unit.unit_no === null">New</h5>
              <h5 v-else>{{ unit.unit_no }}</h5>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div>
                    <img :src="`${publicPath}asset/img/product.png`" class="ml-auto" v-if="unit.asset.picture === null">
                    <img :src="unit.asset.picture" class="ml-auto" v-else/>
                  </div>
                  <div class="unit-text">
                    <h5 class="text-left">
                      {{ unit.asset.asset_name }} <span v-if="unit.asset.internal_number !== null"><b>({{ unit.asset.internal_number }})</b></span>
                      &nbsp;
                      <span class="badge badge-success" v-if="unit.asset.condition === 'ready'">{{ unit.asset.condition }}</span>
                      <span class="badge badge-warning" v-else>{{ unit.asset.condition }}</span>
                    </h5>
                  </div>
                  <!-- <pre>{{ unit.asset }}</pre> -->
                </div>
                <div class="col-md-4">
                  <dl class="row dl-custom font-12">
                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">
                      {{ unit.unit_date | dateFormat('DD/MM/YYYY') }}
                    </dd>

                    <dt class="col-md-4">Type</dt>
                    <dd class="col-md-8">
                      {{ unit.type_id }}
                    </dd>

                    <dt class="col-md-4">Company</dt>
                    <dd class="col-md-8">
                      {{ unit.company_no }}
                    </dd>

                    <dt class="col-md-4">Customer No.</dt>
                    <dd class="col-md-8">
                      <i>{{ unit.customer_no }}</i>
                    </dd>

                    <dt class="col-md-4">Name:</dt>
                    <dd class="col-md-8">
                      {{ unit.customer.name }}
                    </dd>

                    <dt class="col-md-4">Phone:</dt>
                    <dd class="col-md-8">
                      {{ unit.customer.phone }}
                    </dd>
                    <dt class="col-md-4">Product/Service</dt>
                    <dd class="col-md-8">
                      <b class="text-style">{{ unit.product }}</b>
                    </dd>
                  </dl>
                  <hr>
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Check Person</dt>
                    <dd class="col-md-8">
                      {{ unit.check_person}} {{ unit.check_person_name }}
                    </dd>
                    <dt class="col-md-4">Check Date</dt>
                    <dd class="col-md-8">
                      {{ unit.storage_date | dateFormat('DD/MM/YYYY H:m') }}
                    </dd>
                  </dl>
                </div>
                <div class="col-md-4">
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Schedule Date</dt>
                    <dd class="col-md-8">
                      {{ unit.schedule_date | dateFormat('DD/MM/YYYY HH:mm')}}
                    </dd>

                    <dt class="col-md-4">Start Date</dt>
                    <dd class="col-md-8">
                      {{ unit.start_date | dateFormat('DD/MM/YYYY HH:mm') }}
                    </dd>

                    <dt class="col-md-4">Finish Date</dt>
                    <dd class="col-md-8">
                      {{ unit.finish_date | dateFormat('DD/MM/YYYY HH:mm') }}
                    </dd>
                  </dl>
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Sale No.</dt>
                    <dd class="col-md-8">
                      <b class="text-style">{{ unit.sale_no }}</b>
                    </dd>

                    <dt class="col-md-4">Notes</dt>
                    <dd class="col-md-8">
                      <p>{{ unit.notes }}</p>
                    </dd>
                    <dt class="col-md-4">Fuel Bar</dt>
                    <dd class="col-md-8">{{ unit.fuel_bar }}</dd>
                    <dt class="col-md-4">Fuel Total</dt>
                    <dd class="col-md-8">{{ unit.fuel_total }} {{ unit.fuel_uom }}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in unit.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div> -->
      <AssetModal @selectAsset="selectAsset"/>
      <CustomerFormModal @createCustomer="createCustomer" />
      <CustomerListModal @selectCustomerList="selectCustomerList" />
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { mapState } from 'vuex'
import AssetModal from '@/components/asset/AssetModal.vue'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import { getHeader, unitUrl } from '../../config'
import Axios from 'axios'

export default {
  name: 'UnitShow',
  props: ['unit'],
  components: {
    Loading,
    AssetModal,
    CustomerFormModal,
    CustomerListModal
  },
  data () {
    return {
      alert: [],
      publicPath: process.env.BASE_URL,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      unitTypeList: state => state.units.unitTypeList,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    })
  },
  methods: {
    async selectCustomerList (customer) {
      this.unit.customer_no = customer.customer_no
      this.unit.customer = customer
    },
    createCustomer: function (customer) {
      this.unit.customer_no = customer.customer_no
      this.unit.customer = customer
    },
    getCustomerList () {
      this.$store.dispatch('getCustomerList')
    },
    selectAsset (asset) {
      this.unit.asset_no = asset.asset_no
      this.unit.asset = asset
      this.unit.asset.picture = asset.picture + '?size='
    },
    getAsset () {
      this.$store.dispatch('getAssetList')
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    },
    async validate () {
      if (this.unit.asset_no == null) {
        this.alert.push('<b>Unit</b> harus dipilih terlebih dahulu')
      }
      if (this.unit.type_id === 'customer') {
        if (this.unit.customer_no === null) {
          this.alert.push('<b>Customer</b> harus diinput terlebih dahulu')
        }
      }
      // create schedule
      if (this.unit.id === null) {
        if (this.unit.schedule_date === null) {
          this.alert.push('<b>Jadwal</b> harus diinput terlebih dahulu')
        }
      }
    },
    async checkUnit () {
      this.alert = []
      this.$Progress.start()
      this.loader.isLoading = true
      var body = {
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        type_id: this.unit.type_id,
        name: this.unit.name,
        alias: this.unit.alias,
        schedule_date: this.unit.schedule_date,
        storage_date: new Date().toISOString(),
        start_date: this.unit.start_date,
        finish_date: this.unit.finish_date,
        sale_no: this.unit.sale_no,
        notes: this.unit.notes,
        company_no: this.unit.company_no,
        asset_no: this.unit.asset_no,
        customer_no: this.unit.customer_no,
        // check_person: this.authUser.username,
        check_person: this.authUser.username,
        created_by: this.unit.created_by,
        status: 'check',
        lock: false
      }
      console.log(body)
      await Axios.put(unitUrl + '/' + this.unit.id, body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async startUnit () {
      this.alert = []
      this.$Progress.start()
      this.loader.isLoading = true
      var body = {
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        type_id: this.unit.type_id,
        name: this.unit.name,
        alias: this.unit.alias,
        schedule_date: this.unit.schedule_date,
        storage_date: this.unit.storage_date,
        start_date: new Date().toISOString(),
        finish_date: this.unit.finish_date,
        sale_no: this.unit.sale_no,
        notes: this.unit.notes,
        company_no: this.unit.company_no,
        asset_no: this.unit.asset_no,
        customer_no: this.unit.customer_no,
        check_person: this.unit.check_person,
        created_by: this.unit.created_by,
        status: 'start',
        lock: false
      }
      console.log(body)
      await Axios.put(unitUrl + '/' + this.unit.id, body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async finishUnit () {
      this.alert = []
      this.$Progress.start()
      this.loader.isLoading = true
      var body = {
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        type_id: this.unit.type_id,
        name: this.unit.name,
        alias: this.unit.alias,
        schedule_date: this.unit.schedule_date,
        storage_date: this.unit.storage_date,
        start_date: this.unit.start_date,
        finish_date: new Date().toISOString(),
        sale_no: this.unit.sale_no,
        notes: this.unit.notes,
        company_no: this.unit.company_no,
        asset_no: this.unit.asset_no,
        customer_no: this.unit.customer_no,
        check_person: this.unit.check_person,
        created_by: this.unit.created_by,
        status: 'finish',
        lock: true
      }
      console.log(body)
      await Axios.put(unitUrl + '/' + this.unit.id, body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async saveSchedule () {
      this.alert = []
      await this.validate()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var body = {
        unit_no: this.unit.unit_no,
        unit_date: this.unit.unit_date,
        type_id: this.unit.type_id,
        name: this.unit.name,
        alias: this.unit.alias,
        schedule_date: this.unit.schedule_date,
        storage_date: this.unit.storage_date,
        start_date: this.unit.start_date,
        finish_date: this.unit.finish_date,
        sale_no: this.unit.sale_no,
        notes: this.unit.notes,
        company_no: this.unit.company_no,
        asset_no: this.unit.asset_no,
        customer_no: this.unit.customer_no,
        check_person: this.unit.check_person,
        created_by: this.unit.created_by,
        status: 'scheduled',
        lock: false
      }
      console.log(body)
      await Axios.post(unitUrl, body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Succses', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    }
  }
}
</script>

<style>
.img-unit {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.unit-text {
  display: flex;
  justify-content: center;
}
.text-style {
  color: #28A745;
}
</style>
